import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import { Plus, Trash2 } from "lucide-react";

const CrmCustomFieldsPanel = () => {
  const [fields, setFields] = useState([]);
  const [saving, setSaving] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    fetch(`${url}/leads/custom-fields`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => setFields(res?.fields || []))
      .catch(() => setFields([]));
  }, [url, token]);

  const save = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${url}/leads/custom-fields`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ fields }),
      });
      if (!res.ok) throw new Error("Save failed");
      const data = await res.json();
      setFields(data.fields || fields);
      toast.success("Custom fields saved");
    } catch {
      toast.error("Could not save custom fields");
    } finally {
      setSaving(false);
    }
  };

  const addField = () => {
    setFields((prev) => [
      ...prev,
      { id: `field_${Date.now()}`, label: "New field", type: "text", options: [] },
    ]);
  };

  return (
    <div className="crm-custom-fields-settings">
      <div className="crm-integrations__head">
        <strong>Custom fields</strong>
        <button type="button" onClick={addField}>
          <Plus size={14} /> Add field
        </button>
      </div>
      <p className="crm-insights__muted">
        Define extra data fields per tenant — shown on lead cards without code deploy.
      </p>

      {fields.map((field, index) => (
        <div key={field.id || index} className="crm-platform__stage-row">
          <input
            className="crm-platform__input"
            placeholder="Label"
            value={field.label}
            onChange={(e) =>
              setFields((p) => p.map((f, i) => (i === index ? { ...f, label: e.target.value } : f)))
            }
          />
          <select
            className="crm-insights__select"
            value={field.type}
            onChange={(e) =>
              setFields((p) => p.map((f, i) => (i === index ? { ...f, type: e.target.value } : f)))
            }
          >
            <option value="text">Text</option>
            <option value="number">Number</option>
          </select>
          <button type="button" onClick={() => setFields((p) => p.filter((_, i) => i !== index))}>
            <Trash2 size={14} />
          </button>
        </div>
      ))}

      <button type="button" className="crm-platform__save" onClick={save} disabled={saving}>
        {saving ? "Saving…" : "Save custom fields"}
      </button>
    </div>
  );
};

export default CrmCustomFieldsPanel;
